/** Canonical public origin. Used to build Stripe return URLs server-side. */
export const SITE_URL = "https://theroyeffect.com";

export const RESUME_URL: string | null = null;
export const LINKEDIN_URL: string | null = null;
export const X_URL: string | null = null;
export const CONTACT_EMAIL = "rory@theroyeffect.com";
